export const PATIENT_SEND_OTP = "/public/send-otp";
export const PATINET_LOGIN_WITH_PASSWORD_OR_OTP = "/auth/login-rev2";
export const PATIENT_LOGIN_DOCTOR_SLUG = `/public/get-doctor-details-by-slug`;
export const PATIENT_SET_PASSWORD = "/patient/set-password";
export const PATIENT_LOGIN = "/auth/login";
